import React from 'react';
import './Fees.css';

const insurance = [
  'BlueCross BlueShield',
  'HealthPartners MN',
  'Hennepin Health',
  'United Health',
  'PreferredOne',
  'UCare',
];

const Fees = ({ onNavigate }) => {
  return (
    <div className="fees">
      <p className="fees-label">Investment in Your Wellbeing</p>
      <h2 className="fees-heading">Accepted Insurance</h2>
      <hr className="fees-rule" />

      <p className="fees-intro">
        I'm in-network with the plans listed below, helping make quality mental
        health care more accessible. Don't see your insurance? Out-of-network
        benefits may still apply — feel free to reach out.
      </p>

      <div className="fees-content">
        <ul className="insurance-list">
          {insurance.map((ins) => (
            <li key={ins} className="insurance-pill">{ins}</li>
          ))}
        </ul>
      </div>

      <div className="fees-cta">
        <p className="fees-cta-text">Questions about your coverage?</p>
        <button className="fees-cta-btn" onClick={() => onNavigate && onNavigate('contact')}>
          Get in Touch
        </button>
      </div>
    </div>
  );
};

export default Fees;